<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'TIPOOCUPACION.LBL_TIPOOCUPACIONCONFIGURACION' | translate}}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
    <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
            label="{{ 'BTN_AGREGAR' | translate}}"></button>
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
           (input)="dt.filterGlobal($event.target.value, 'contains')"
           [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carTabla" #dt
             [value]="lisTipoOcupacion" selectionMode="single" dataKey="idTipoOcupacionConfiguracion"
             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"  let-row let-index="rowIndex">
        <tr [pSelectableRow]="row">
          <td>{{row.codigoTipoOcupacion}}</td>
          <td>{{row.nombreTipoOcupacion}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorFlujoDigital" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down" data-toggle="tooltip"
                      title="{{'BTN_ABAJO' | translate}}" *ngIf="index >=0 && index<lisTipoOcupacion.length-1"
                      pButton (click)="cambiarOrden(row, false)"></button>
              <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up" data-toggle="tooltip"
                      title="{{'BTN_ARRIBA' | translate}}" pButton *ngIf="index >0"
                      (click)="cambiarOrden(row, true)"
              ></button>
            </div>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                      title="{{'BTN_VISUALIZAR' | translate}}"
                      pButton (click)="ver(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="menu.editar"
                      (click)="editar(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-file-text" data-toggle="tooltip"
                      title="{{'TIPOOCUPACION.BTN_CAPACIDADPAGO' | translate}}" pButton *ngIf="menu.editar"
                      (click)="capacidadPago(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
